import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  procedureTemplateService,
  type CreateSectionDto,
} from '@/services/procedure-template.service';
import { procedureKeys } from './useProcedureTemplates';

export function useCreateSection(templateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateSectionDto) => procedureTemplateService.createSection(templateId, dto),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}

export function useUpdateSection(templateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ sectionId, title }: { sectionId: string; title: string }) =>
      procedureTemplateService.updateSection(templateId, sectionId, { title }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}

export function useDeleteSection(templateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (sectionId: string) =>
      procedureTemplateService.deleteSection(templateId, sectionId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}

export function useReorderSections(templateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (orderedIds: string[]) =>
      procedureTemplateService.reorderSections(templateId, orderedIds),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: procedureKeys.detail(templateId) });
    },
  });
}
